import { INews } from 'api/types/_news';
import { CONFIG_OPTION_TOAST_ERROR, CONFIG_OPTION_TOAST_INFO, CONFIG_OPTION_TOAST_NORMAL } from 'common/toast';
import DatePickerCustom from 'components/Common/DatePickerCustom';
import DropdownStatus from 'components/Common/DropdownStatus';
import LabelWrapper from 'components/Common/LabelWrapper';
import ModalConfirm from 'components/Common/ModalConfirm';
import NewsTableContainer from 'components/Common/NewsTableContainer';
import { useRole } from 'components/Hooks/UserHooks';
import { COLOR_TYPE_SENTIMENT, COLORS_SECTION_KEYWORD, COLORS_SENTIMENT_NEWS, COLORS_STATUS_NEWS, CONFIG_ALLOW_SANITIZE_HTML, SECTION_KEYWORD, SECTION_KEYWORD_OPTIONS, SENTIMENT_NEWS_OPTIONS, STATUS_NEWS_OPTIONS, TYPE_NEWS_OPTIONS } from 'helpers/constans';
import { formatNumberWithCommas } from 'helpers/format';
import { ROLES_FOR_APP, isHavePermissionRole } from 'helpers/role';
import moment from "moment";
import React, { useCallback, useEffect, useMemo, useRef, useState } from "react";
import CountUp from 'react-countup';
import { useTranslation } from "react-i18next";
import InfiniteScroll from 'react-infinite-scroll-component';
import { Link, useNavigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Accordion, AccordionItem, ButtonGroup, Card, CardBody, CardHeader, Col, Collapse, Container, DropdownItem, DropdownMenu, DropdownToggle, Input, Label, Modal, ModalBody, ModalFooter, ModalHeader, Row, Spinner, UncontrolledDropdown } from "reactstrap";
import { NumberParam, StringParam, useQueryParams, withDefault, } from "use-query-params";
import BreadCrumb from "../../../components/Common/BreadCrumb";
import { cancelMyNews, downloadNews, getMyNewsByNormal, getNews } from "../../../store/thunks";
import CopyPreventionComponent from '../Components/CopyPreventionComponent';
import HighlightText from '../Components/HighlightText';
import DraggableButtons from '../Components/DraggableButtons';
import sanitizeHtml from 'sanitize-html';
import NestingFilter from '../Components/NestingFilter';
import CopyTextToClipboard from '../Components/CopyTextToClipboard';
import FeatherIcon from "feather-icons-react";

import flagus from "../../../assets/images/flags/us.svg";
import flagkorea from "../../../assets/images/flags/kr.svg";
import flagjapan from "../../../assets/images/flags/jp.svg";
import flagchina from "../../../assets/images/flags/cn.svg";
import DropdownOption from 'components/Common/DropdownOption';


interface Option {
  label: string;
  value: string;
}

export interface Tag {
  id: string;
  text: string;
}

const TYPE_SELECT_DEFAULT: string = 'created_at';
const FLAGS: any = {
  'ko': flagkorea,
  'en': flagus,
  'ja': flagjapan,
  'cn-zh': flagchina
};

const NewsList = () => {
  let document_w: any = window.document;
  const { t, i18n } = useTranslation();
  const { userPermissions } = useRole();
  const navigate = useNavigate();

  const modalRef = useRef<any>(null);
  const modalBodyInnerRef = useRef<any>(null);

  const isModalFullScreenRef = useRef<number>(0);

  const isFirstLoadingPageRef = useRef<any>(true);

  const STATUS_NEWS_OPTIONS_LANG = STATUS_NEWS_OPTIONS?.map((item: any) => ({
    value: item?.value,
    label: t(item?.label),
  }));

  const SECTION_KEYWORD_OPTIONS_LANG = SECTION_KEYWORD_OPTIONS?.map((item: any) => ({
    value: item?.value,
    label: t(item?.label),
  }));

  const TYPE_NEWS_OPTIONS_LANG = TYPE_NEWS_OPTIONS?.map((item: any) => ({
    value: item?.value,
    label: t(item?.label),
  }));


  const SENTIMENT_NEWS_OPTIONS_LANG = SENTIMENT_NEWS_OPTIONS?.map((item: any) => ({
    value: item?.value,
    label: t(item?.label),
  }));

  const START_DATE = `${moment().subtract(7, 'days').format("Y-MM-DD")}`;
  const END_DATE = `${moment().format("Y-MM-DD")}`;

  const [query, setQuery]: any = useQueryParams({
    time_request: withDefault(NumberParam, 0),
    page: withDefault(NumberParam, 1),
    limit: withDefault(NumberParam, 100),
    sort_by: withDefault(StringParam, TYPE_SELECT_DEFAULT),
    order_by: withDefault(StringParam, 'DESC'),
    start_date: withDefault(StringParam, START_DATE),
    end_date: withDefault(StringParam, END_DATE),
    keyword: withDefault(StringParam, ''),
    title: withDefault(StringParam, ''),
    status: withDefault(StringParam, ''),
    section: withDefault(StringParam, ''),
    sentiment_value: withDefault(StringParam, ''),
    news_tab: withDefault(StringParam, ''),
  });

  const [keywordSearch, setKeywordSearch] = useState<string>(query?.keyword || "");
  const [titleSearch, setTitleSearch] = useState<string>(query?.title || "");

  const [statusSearch, setStatusSearch] = useState<Option | null>(STATUS_NEWS_OPTIONS_LANG?.find((item) => String(item?.value) === String(query?.status)) || null);

  const [sentimentSearch, setSentimentSearch] = useState<Option | null>(SENTIMENT_NEWS_OPTIONS_LANG?.find((item) => String(item?.value) === String(query?.sentiment_value)) || null);

  const [sectionSearch, setSectionSearch] = useState<Option | null>(SECTION_KEYWORD_OPTIONS_LANG?.find((item) => String(item?.value) === String(query?.section)) || null);

  const [typeSearch, setTypeSearch] = useState<Option | null>(TYPE_NEWS_OPTIONS_LANG?.find((item) => String(item?.value) === String(query?.news_tab)) || null);

  const [dateSearch, setDateSearch] = useState<any[]>([query?.start_date ? moment(query?.start_date, 'Y-MM-DD').toDate() : null, query?.end_date ? moment().toDate() : null]);
  const [startDate, endDate] = dateSearch;

  const [newsDetail, setNewsDetail] = useState<INews | null>(null);

  const [typeShowList, setTypeShowList] = useState<'CARD' | 'TABLE'>('TABLE');

  const [isDownloading, setIsDownloading] = useState<boolean>(false);

  const [isCopyLoading, setIsCopyLoading] = useState<boolean>(false);

  const [isOpenPhoto, setIsOpenPhoto] = useState<boolean>(false);

  const [newsCancel, setNewsCancel] = useState<INews | null>(null);
  const [isConfirmLoading, setIsConfirmLoading] = useState<boolean>(false);

  const [listNews, setListNews] = useState<{ list: INews[], total: number }>({ list: [], total: 0 });
  const [isListNewsLoading, setIsListNewsLoading] = useState<boolean>(false);

  const handleQueryData = async () => {
    setIsListNewsLoading((prev) => true);
    if (isFirstLoadingPageRef?.current === true) {
      isFirstLoadingPageRef.current = false;
      setQuery({
        ...query,
        type_page_no_param: '',
        end_date: moment(new Date(endDate)).format("Y-MM-DD"),
        page: 1
      });
      return;
    }
    isFirstLoadingPageRef.current = false;
    const res: any = await getMyNewsByNormal(query);
    setListNews((prev: any) => ({
      list: res?.data?.list || [],
      total: res?.data?.pagination?.total || 0,
    }));
    setIsListNewsLoading((prev) => false);

    if (!!newsDetail && query?.type_page_no_param) {
      if (query?.type_page_no_param === 'prev') {
        setNewsDetail((_prev) => res?.data?.list[res?.data?.list?.length - 1]);
        return;
      }
      if (query?.type_page_no_param === 'next') {
        setNewsDetail((_prev) => res?.data?.list[0]);
        return;
      }
    }
  };

  const handleLoadMore = () => {
    setQuery({
      ...query,
      page: query?.page + 1,
      type_page_no_param: 'next'
    });
  }

  const handleLoadPrev = () => {
    setQuery({
      ...query,
      page: query?.page - 1,
      type_page_no_param: 'prev'
    });
  }

  useEffect(() => {
    handleQueryData();
  }, [JSON.stringify(query), isFirstLoadingPageRef?.current]);

  const searchData = () => {
    const queryNew = {
      ...query,
      start_date: startDate ? moment(new Date(startDate)).format("Y-MM-DD") : '',
      end_date: endDate ? moment(new Date(endDate)).format("Y-MM-DD") : '',
      keyword: keywordSearch || '',
      title: titleSearch || '',
      status: statusSearch?.value,
      section: sectionSearch?.value,
      sentiment_value: sentimentSearch?.value,
      news_tab: typeSearch?.value,
      page: 1,
      time_request: + new Date()
    };
    if (JSON.stringify(query) !== JSON.stringify(queryNew)) {
      setListNews((prev: any) => ({
        list: [],
        total: 0,
      }));
    }
    setQuery(queryNew);
  };

  const resetData = () => {
    const queryNew = {
      title: '',
      keyword: '',
      status: '',
      section: '',
      sentiment_value: '',
      news_tab: '',
      start_date: `${moment().subtract(7, 'days').format("Y-MM-DD")}`,
      end_date: `${moment().format("Y-MM-DD")}`,
      sort_by: TYPE_SELECT_DEFAULT,
      order_by: 'DESC',
      page: 1,
      time_request: + new Date(),
    };
    if (JSON.stringify(query) !== JSON.stringify(queryNew)) {
      setListNews((prev: any) => ({
        list: [],
        total: 0,
      }));
    }
    setQuery(queryNew, "push");
    setTitleSearch((_prev) => "");
    setKeywordSearch((_prev) => "");
    setStatusSearch(null);
    setSectionSearch(null);
    setSentimentSearch(null);
    setTypeSearch(null);
    setDateSearch([moment(queryNew?.start_date || "", 'Y-MM-DD').toDate(), moment(queryNew?.end_date || "", 'Y-MM-DD').toDate()]);
  };

  const handleGetDetailNews = async (id_news: string | number) => {
    try {
      getNews(id_news);
    } catch (error) {
      //
    }
  };

  const handleSetNewsDetail = (detail: INews | null) => {
    setNewsDetail((_prev) => detail);
    if (!!detail) {
      handleGetDetailNews(detail?.id);
    }
    if ((window?.innerWidth <= 900)) {
      setTimeout(async () => {
        try {
          if (!!detail) {
            if (isModalFullScreenRef.current <= 0 && !(!document_w.fullscreenElement && !document_w.mozFullScreenElement && !document_w.webkitFullscreenElement)) {
              isModalFullScreenRef.current = 0;
            } else if ((!document_w.fullscreenElement && !document_w.mozFullScreenElement && !document_w.webkitFullscreenElement)) {
              isModalFullScreenRef.current = 1;
              if (document_w.documentElement.requestFullscreen) {
                document_w.documentElement.requestFullscreen();
              } else if (document_w.documentElement.mozRequestFullScreen) {
                document_w.documentElement.mozRequestFullScreen();
              } else if (document_w.documentElement.webkitRequestFullscreen) {
                document_w.documentElement.webkitRequestFullscreen();
              }
            }
          }
        } catch (error) {
          //console.error("Failed to enter fullscreen:", error);
        }
      }, 280);
    }
  }

  const handleSetNewsCancel = (detail: INews | null) => {
    setNewsCancel((_prev) => detail);
  }

  const onCloseClick = () => {
    handleSetNewsDetail(null);
    setCurrentLang((_prev) => 'ko');
    if (window?.innerWidth <= 900) {
      setTimeout(async () => {
        try {
          if (isModalFullScreenRef?.current > 0) {
            isModalFullScreenRef.current = 0;
            if (document_w.cancelFullScreen) {
              document_w.cancelFullScreen();
            } else if (document_w.mozCancelFullScreen) {
              document_w.mozCancelFullScreen();
            } else if (document_w.webkitCancelFullScreen) {
              document_w.webkitCancelFullScreen();
            }
          }
        } catch (error) {
          //console.error("Failed to enter fullscreen:", error);
        }
      }, 280);
    }

  }

  const scrollModalBodyToTop = () => {
    if (modalBodyInnerRef.current) {
      modalBodyInnerRef.current.scrollTo({
        top: 0,
      });
    }
  };

  const handlePreviousNews = (index_news_current: number = 0) => {
    if (listNews?.list?.length) {
      const indexNewsPrevious = Number(index_news_current) - 1;
      const newsPrevious = listNews?.list[indexNewsPrevious];
      const news2Previous = listNews?.list[indexNewsPrevious - 1];
      if (!!newsPrevious) {
        handleSetNewsDetail({
          ...(newsPrevious),
          index: indexNewsPrevious,
          disabled_prev: false,
          disabled_next: false,
        });
        scrollModalBodyToTop();
        setCurrentLang((_prev) => 'ko');
      }
      if (!newsPrevious) {
        if (Number(query?.page) > 1) {
          handleLoadPrev();
        } else {
          toast(t('There is no news article anymore!'), CONFIG_OPTION_TOAST_INFO);
        }
      }
    }
  };

  const handleNextNews = (index_news_current: number = 0) => {
    if (listNews?.list?.length) {
      const indexNewsNext = Number(index_news_current) + 1;
      const newsNext = listNews?.list[indexNewsNext];
      const news2Next = listNews?.list[indexNewsNext + 1];
      if (!!newsNext) {
        handleSetNewsDetail({
          ...(newsNext),
          index: indexNewsNext,
          disabled_prev: false,
          disabled_next: false
        });
        scrollModalBodyToTop();
        setCurrentLang((_prev) => 'ko');
      }
      if (!newsNext) {
        if (Number(query?.page) < Math.ceil(Number(listNews?.total) / Number(query?.limit || 300))) {
          handleLoadMore();
        } else {
          toast(t('There is no news article anymore!'), CONFIG_OPTION_TOAST_INFO);
        }
      }
    }
  };

  const [currentLang, setCurrentLang] = useState<string>('ko');
  const handleChangeLang = (_lang: string) => {
    const lang = newsDetail?.translates?.find((tr) => tr?.language_code === _lang);
    setNewsDetail((_prev) => (
      {
        ..._prev,
        title: lang?.title,
        body: lang?.body,
      } as INews
    ));
    setCurrentLang((_prev) => _lang);
  };

  // Column
  const columns = useMemo(
    () => [
      {
        Header: t('ID'),
        accessor: "id",
        filterable: true,
        sortable: false,
        thWidth: 90,
        Cell: (cell: any) => (
          <>
            <div style={{ minWidth: '60px' }}>{
              cell?.value
            }</div>
          </>
        ),
      },
      // {
      //   Header: t('Status'),
      //   accessor: "status",
      //   filterable: false,
      //   sortable: false,
      //   thClass: "align-middle text-center",
      //   thWidth: i18n?.language === 'en' ? 90 : 80,
      //   Cell: (cell: any) => {
      //     const item: any = cell?.row?.original;
      //     return (
      //       <div style={{ minWidth: '60px' }} className="text-center fs-16">
      //         <span className={`rounded-pill badge bg-${COLORS_STATUS_NEWS[`${cell?.value || 0}`] || 'success'}`}>
      //           {STATUS_NEWS_OPTIONS_LANG?.find((s) => String(s?.value) === String(item?.status))?.label || ''}
      //         </span>
      //       </div>
      //     );
      //   }
      // },<span className='badge bg-primary-subtle text-primary'>{item?.category?.name || ''}</span>
      // {
      //   Header: t('Section'),
      //   accessor: "section",
      //   filterable: true,
      //   sortable: false,
      //   thWidth: i18n?.language === 'en' ? 130 : 90,
      //   thClass: 'align-middle text-center',
      //   Cell: (cell: any) => {
      //     const item = cell?.row?.original;
      //     return (<div style={{ minWidth: '70px' }} className="text-center d-flex flex-column justify-content-center align-items-center gap-1 fs-16">
      //       {!!item?.category?.name ? <>-</> : <span key={item?.section} className={`badge bg-${COLORS_SECTION_KEYWORD[`${item?.section || ''}`] || 'success'}-subtle text-${COLORS_SECTION_KEYWORD[`${item?.section || ''}`] || 'success'}`}>
      //         {SECTION_KEYWORD_OPTIONS_LANG?.find((s) => String(s?.value) === String(item?.section))?.label || ''}
      //       </span>}
      //     </div>)
      //   },
      // },
      {
        Header: t('Type'),
        accessor: "type",
        filterable: true,
        sortable: false,
        thWidth: i18n?.language === 'en' ? 150 : 120,
        thClass: 'align-middle text-center',
        Cell: (cell: any) => {
          const item = cell?.row?.original;
          return (<div style={{ minWidth: i18n?.language === 'en' ? '120px' : '90px' }} className="text-center d-flex flex-column justify-content-center align-items-center gap-1 fs-16">
            {!!SECTION_KEYWORD_OPTIONS_LANG?.find((s) => String(s?.value) === String(item?.section))?.label ? <span className="rounded-pill badge bg-success-subtle text-success">{t('AI News')}</span> :
              String(item?.section) === String(SECTION_KEYWORD.MANUAL) ? <span className="rounded-pill badge bg-info-subtle text-info">{t('AI Custom News')}</span> : (
                [String(SECTION_KEYWORD.GOVERNMENT_IMAGE_BASED_NEWS), String(SECTION_KEYWORD.GOVERNMENT_LOGO_BASED_NEWS)].includes(String(item?.section)) ? <span className="rounded-pill badge bg-warning-subtle text-warning">{t('Government News')}</span> : <span className="rounded-pill badge bg-primary-subtle text-primary">{t('Boosting News')}</span>
              )
            }
          </div>)
        },
      },
      {
        Header: t('Keyword'),
        accessor: "keyword",
        filterable: true,
        sortable: true,
        thWidth: 100,
        Cell: (cell: any) => {
          const item = cell?.row?.original;
          return (<>
            <div style={{ minWidth: '80px' }} className="fs-15">{cell?.value || '-'}</div>
          </>)
        },
      },
      {
        Header: t('News Title'),
        accessor: "title",
        filterable: true,
        sortable: false,
        thClass: 'align-middle',
        thWidth: !listNews?.list?.length ? 100 : (window.innerWidth < 1650 ? 270 : 600),
        Cell: (cell: any) => {
          const item = cell?.row?.original;
          return (<>
            <div style={{ minWidth: '250px', maxWidth: '600px' }} className={`fs-15 cursor-pointer hover-underline`} onClick={(e) => { e.preventDefault(); handleSetNewsDetail({ ...item, index: cell?.row?.index }) }}>
              {cell?.value || '-'}
            </div>
          </>)
        },
      },
      // {
      //   Header: t('Monthly Search Volume'),
      //   accessor: "search_volume",
      //   filterable: true,
      //   sortable: true,
      //   thWidth: i18n?.language === 'en' ? 200 : 140,
      //   thClass: 'align-middle text-center',
      //   Cell: (cell: any) => {
      //     const item = cell?.row?.original;
      //     return (<>
      //       <div className="text-center" style={{ minWidth: i18n?.language === 'en' ? '180px' : '120px' }}>{formatNumberWithCommas(cell?.value || 0)}</div>
      //     </>)
      //   },
      // },
      {
        Header: t('Competing Articles'),
        accessor: "news_count",
        filterable: true,
        sortable: false,
        thWidth: i18n?.language === 'en' ? 160 : 120,
        thClass: 'align-middle text-center',
        Cell: (cell: any) => {
          const item = cell?.row?.original;
          return (<>
            <div className="text-center" style={{ minWidth: i18n?.language === 'en' ? '150px' : '100px' }}>{formatNumberWithCommas(cell?.value || 0)}</div>
          </>)
        },
      },
      // {
      //   Header: t("PA Index"),
      //   accessor: "pa_index",
      //   thClass: 'align-middle text-center align-top',
      //   filterable: false,
      //   sortable: true,
      //   thWidth: 120,
      //   Cell: (cell: any) => {
      //     const item: any = cell?.row?.original;
      //     return (
      //       <div className="text-center">
      //         <div style={{ minWidth: "100px" }} className={`text-center`}>
      //            {cell?.value !== null ? formatNumberWithCommas(cell?.value || 0) : '-'}
      //         </div>
      //       </div>
      //     );
      //   },
      // },
      {
        Header: t("Sentiment"),
        thClass: 'align-middle text-center align-top',
        filterable: false,
        sortable: false,
        thWidth: 120,
        Cell: (cell: any) => {
          const item: any = cell?.row?.original;
          return (
            <div className="text-center">
              <div style={{ minWidth: "100px" }} className={`text-center text-${COLOR_TYPE_SENTIMENT?.[`${item?.sentiment?.sentiment_value || '-'}`] || 'muted'}`}>
                {t(`${item?.sentiment?.sentiment_value || '-'}`)}
              </div>
            </div>
          );
        },
      },
      {
        Header: t('Created At'),
        accessor: "created_at",
        filterable: true,
        sortable: true,
        thWidth: 120,
        thClass: 'align-middle text-end',
        Cell: (cell: any) => {
          const arrDate = String(cell?.value || '').split(' ');
          return (
            <div className="text-end pe-3" style={{ minWidth: '100px' }}>
              <span><span>{arrDate?.[0] || ''}</span></span>
            </div>
          )
        },
      },
      {
        Header: t('Action'),
        thClass: 'align-middle text-center',
        thWidth: 100,
        sortable: false,
        Cell: (cell: any) => {
          const item: any = cell?.row?.original;
          return (
            <ul className="list-inline flex-wrap justify-content-center hstack gap-2 mb-0" style={{ minWidth: '90px' }}>
              {isHavePermissionRole([ROLES_FOR_APP.AI_NEWS, ROLES_FOR_APP.BOOSTING_NEWS], userPermissions) &&
                <>
                  {/* <li className=" list-inline-item me-0" id={`detail-us-${item?.id}`}>
                    <Link className="btn btn-sm btn-soft-danger edit-item-btn" to="#"
                      onClick={(e) => { e.preventDefault(); handleSetNewsCancel({ ...item, index: cell?.row?.index }) }}
                    >
                      {t('Button Cancel News')}
                    </Link>
                  </li> */}

                  <li className=" list-inline-item me-0" id={`detail-us-${item?.id}`}>
                    <Link className="btn btn-sm btn-soft-primary edit-item-btn" to="#"
                      onClick={(e) => { e.preventDefault(); handleSetNewsDetail({ ...item, index: cell?.row?.index }) }}
                    >
                      {t('Button Detail News')}
                    </Link>
                  </li>
                </>}
            </ul>
          );
        },
      },
    ],
    [i18n?.language, query, listNews?.list?.length, userPermissions]
  );

  const handleChangePage = useCallback((page: any) => {
    setQuery({ page: page + 1 })
  }, []);

  const handleChangeSorting = useCallback((sortBy: any) => {
    setListNews((prev: any) => ({
      list: [],
      total: 0,
    }));
    setQuery((_prev: any) => {
      return ({ ..._prev, ...sortBy, page: 1 });
    });
  }, []);

  const handleCallAllOption = async () => {
    try {
      // const [resRole]: any = await Promise.all([getAllRoles()]);
      // if (resRole?.data) {
      //   setListRole((_prev) => resRole?.data);
      // }
    } catch (error: any) {
      return error;
    }
  };

  async function downloadFileFromUrl(fileUrl: string, fileName: string) {
    try {
      // Send a file download request using Fetch API
      const response = await fetch(fileUrl);

      // Check if the response is unsuccessful
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      // Get the file content as a blob
      const blob = await response.blob();

      // Create a blob URL
      const blobUrl = window.URL.createObjectURL(blob);

      // Create a link to download the file
      const link = document.createElement('a');
      link.href = blobUrl;
      link.download = fileName; // Set the downloaded file name
      document.body.appendChild(link);

      // Trigger the file download
      link.click();

      // Revoke the blob URL and remove the link element
      window.URL.revokeObjectURL(blobUrl);
      document.body.removeChild(link);
    } catch (error) {
      console.error("Download failed:", error);
    }
  }

  const copyTextToClipboard = useCallback(async (textHTML: string) => {
    const replacedContent = String(textHTML).replace(/<br\s*\/?>/gi, '\n\n');
    const cleanHTML = sanitizeHtml(replacedContent, CONFIG_ALLOW_SANITIZE_HTML);
    if ('clipboard' in navigator) {
      await navigator.clipboard.writeText(cleanHTML);
    } else {
      document.execCommand('copy', true, cleanHTML);
    }
    toast(`${t('The news has been copied to the clipboard. The title and body copy feature has been activated.')}`, CONFIG_OPTION_TOAST_INFO);
  }, []);

  const handleCopyNews = async (id_news: string | number = '') => {
    try {
      if (!id_news) {
        return;
      }
      onCloseConfirmClick();
      setIsCopyLoading((_prev) => true);
      const response: any = await downloadNews(id_news, { type: 'COPY', language_code: currentLang });
      setIsCopyLoading((_prev) => false);
      if (response?.data) {
        copyTextToClipboard(`${response?.data?.title}\n\n${response?.data?.body}`);
      } else {
        toast(`${response}`, CONFIG_OPTION_TOAST_ERROR);
      }
    } catch (error: any) {
      setIsCopyLoading((_prev) => false);
      toast(`${error?.message || ''}`, CONFIG_OPTION_TOAST_ERROR);
      return error;
    }
  }

  const handleDownloadNews = async (id_news: string | number = '', type_file: 'WORD' | 'PDF' = 'WORD') => {
    try {
      if (!id_news) {
        return;
      }
      setIsDownloading((_prev) => true);
      const response: any = await downloadNews(id_news, { type: type_file, language_code: currentLang });
      if (response?.data) {
        setIsDownloading((_prev) => false);
        // Get file name from URL or set default name
        const urlParts = response?.data?.url?.split('/');
        const fileName = urlParts[urlParts.length - 1] || 'My_News.pdf';
        downloadFileFromUrl(response?.data?.url, fileName);
        setListNews((_prev) => (
          {
            list: _prev?.list?.map((item) => (item?.id === id_news ? { ...item, status: 1 } : item)),
            total: _prev?.total,
          }
        ));
        setNewsDetail((_prev) => ({ ..._prev, status: 1 }) as INews);
      } else {
        setIsDownloading((_prev) => false);
        toast(`${response}`, CONFIG_OPTION_TOAST_ERROR);
      }
    } catch (error: any) {
      setIsDownloading((_prev) => false);
      toast(`${error?.message || ''}`, CONFIG_OPTION_TOAST_ERROR);
      return error;
    }
  }

  const handleActionCancel = async () => {
    if (!newsCancel) { return; };
    try {
      setIsConfirmLoading((_prev) => true);
      const response: any = await cancelMyNews(newsCancel?.id);
      if (response?.code === 200) {
        setIsConfirmLoading((_prev) => false);
        setNewsCancel((_prev) => null);
        setNewsDetail((_prev) => null);
        toast(`${t('The process has been completed.')}`, CONFIG_OPTION_TOAST_NORMAL);
        setListNews((_prev) => (
          {
            list: _prev?.list?.filter((item) => (item?.id !== newsCancel?.id)),
            total: Number(_prev?.total) - 1,
          }
        ));
      } else {
        setIsConfirmLoading((_prev) => false);
        setNewsCancel((_prev) => null);
        toast(`${response}`, CONFIG_OPTION_TOAST_ERROR);
      }
    } catch (error: any) {
      setIsConfirmLoading((_prev) => false);
      toast(`${error?.message || ''}`, CONFIG_OPTION_TOAST_ERROR);
      return error;
    }
  };

  const handleConfirmPhotoNews = () => {
    setIsOpenPhoto(true);
  };

  const handleOpenTabPhotoNews = () => {
    setIsOpenPhoto(false);
    window.open(`https://www.google.com/search?q=${newsDetail?.keyword}&sclient=img&udm=2`, '_blank');
  };

  const onCloseConfirmClick = () => {
    setNewsCancel((_prev) => null);
  }

  const handleChangePicker = (values: any[] = []) => {
    setDateSearch((_prev: any) => values);
  }

  const handelChangeSection = (section_search: Option) => {
    const queryNew = {
      ...query,
      section: section_search?.value,
      page: 1,
      time_request: + new Date()
    };
    if (JSON.stringify(query) !== JSON.stringify(queryNew)) {
      setListNews((prev: any) => ({
        list: [],
        total: 0,
      }));
    }
    setQuery(queryNew);
    setSectionSearch(section_search)
  }

  useEffect(() => {
    handleCallAllOption();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    document.title = `${t('My News')} | ${t('PRESS Ai')}`;
    document.body.classList.remove('vertical-sidebar-enable');
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [i18n?.language]);

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <BreadCrumb title={t('My News')} pageTitle={t('Home')} />
          <Row>
            {isHavePermissionRole(ROLES_FOR_APP.AI_NEWS, userPermissions) && (
              <Col lg={12}>
                <Card id="customerList" style={{ boxShadow: '0px 3px 4px 0px rgba(0, 0, 0, 0.03)' }}>
                  <CardHeader className="border-0">
                    <Row className="g-4 align-items-center">
                      <div className="col-6">
                        <div>
                          <h5 className="card-title mb-0">
                            <span className="me-2">{t('Total')}:</span>
                            {(isListNewsLoading && query?.page === 1) ? <Spinner size="sm" className="text-primary"></Spinner> : (<CountUp
                              start={0}
                              end={listNews?.total || 0}
                              duration={1}
                              className="text-primary"
                            />)}
                          </h5>
                        </div>
                      </div>
                      <div className="col-6 text-end">
                        <button
                          type="button"
                          className="btn btn-info py-1 px-2"
                          onClick={() => setTypeShowList((_prev) => (_prev === 'CARD' ? 'TABLE' : 'CARD'))}
                        >
                          {typeShowList === 'TABLE' ? <i className="ri-list-check-2 align-center fs-20" /> : <i className="ri-table-2 align-center fs-20" />}
                        </button>
                      </div>
                    </Row>
                  </CardHeader>
                  <div className=" border border-dashed border-end-0 border-start-0 card-body mt-0 pb-4 px-0 px-lg-3 pt-0 pt-lg-3">
                    <NestingFilter>
                      <Row className="g-4 align-items-end mt-0 mb-2">

                        <Col sm={6} md={6} lg={4} xl={2} xxl={2} className='mt-3 mt-xl-2 order-1 order-xl-0'>
                          <LabelWrapper label={t('Type')} isShow={true}>
                            <DropdownStatus
                              name="type"
                              dataList={TYPE_NEWS_OPTIONS_LANG || []}
                              placeholder={`${t("Type")}...`}
                              className="dropdown-status-rounded z-hight"
                              classNamePrefix="name-prefix"
                              initialValue={typeSearch || null}
                              onChangeSelect={(e: any) => setTypeSearch(e)}
                              isHasOptionAll={true}
                              optionAll={{ label: t('All'), value: '' }}
                              colors={['danger', 'success', 'primary', 'info', 'warning']}
                            />
                          </LabelWrapper>
                        </Col>

                        <Col sm={6} md={6} lg={4} xl={2} xxl={2} className='mt-3 mt-xl-2 order-2 order-xl-0'>
                          <LabelWrapper label={t('Keyword')} isShow={!!keywordSearch}>
                            <Input
                              type="text"
                              className="form-control search"
                              placeholder={`${t('Keyword')}...`}
                              value={keywordSearch}
                              onChange={(e) => setKeywordSearch(e.target.value)}
                              onKeyDown={(e) => {
                                if (e.key === "Enter") {
                                  searchData();
                                }
                              }}
                            />
                          </LabelWrapper>
                        </Col>
                        <Col sm={12} md={6} lg={8} xl={3} xxl={3} className='mt-3 mt-xl-2 order-2 order-xl-0'>
                          <LabelWrapper label={t('News Title')} isShow={!!titleSearch}>
                            <Input
                              type="text"
                              className="form-control search"
                              placeholder={`${t('News Title')}...`}
                              value={titleSearch}
                              onChange={(e) => setTitleSearch(e.target.value)}
                              onKeyDown={(e) => {
                                if (e.key === "Enter") {
                                  searchData();
                                }
                              }}
                            />
                          </LabelWrapper>
                        </Col>

                        <Col sm={6} md={6} lg={4} xl={2} xxl={2} className='mt-3 mt-xl-2 order-1 order-xl-0'>
                          <LabelWrapper label={t('Sentiment')} isShow={true}>
                            <DropdownStatus
                              name="sentiment"
                              dataList={SENTIMENT_NEWS_OPTIONS_LANG || []}
                              placeholder={`${t("Sentiment")}...`}
                              className="dropdown-status-rounded z-hight"
                              classNamePrefix="name-prefix"
                              initialValue={sentimentSearch || null}
                              onChangeSelect={(e: any) => setSentimentSearch(e)}
                              isHasOptionAll={true}
                              optionAll={{ label: t('All'), value: '' }}
                              colors={COLORS_SENTIMENT_NEWS}
                            />
                          </LabelWrapper>
                        </Col>
                        <Col sm={6} md={6} lg={4} xl={3} xxl={3} className='date-picker-wrapper-custom mt-3 mt-xl-2 order-1 order-xl-0'>
                          <LabelWrapper label={t('Date')} isShow={!!startDate || !!endDate}>
                            <DatePickerCustom
                              placeholder={`${t('Start Date')} - ${t('End Date')}`}
                              startDate={startDate || null}
                              endDate={endDate || null}
                              onChangePicker={handleChangePicker}
                              showOptions={[
                                'today', 'yesterday', 'two_day_ago',
                                'last_3_days', 'last_7_days', 'last_14_days', 'last_30_days',
                                'this_week', 'last_week',
                                'this_month', 'last_month',
                              ]}
                            />
                          </LabelWrapper>
                        </Col>
                        <Col sm={12} md={6} lg={12} xl={12} xxl={12} className="order-2 order-xl-0 hstack gap-1 justify-content-center justify-content-sm-end justify-content-md-end justify-content-lg-end justify-content-xl-end mt-3 mt-lg-3">
                          <div>
                            <button
                              type="button"
                              className="btn btn-primary me-2 "
                              onClick={searchData}
                              disabled={isListNewsLoading}
                            >
                              <i className="ri-search-line align-bottom me-1"></i>{" "}
                              {t('Button Search')}
                            </button>
                            <button
                              type="button"
                              className="btn btn-secondary fs-14"
                              onClick={resetData}
                            >
                              <i className="ri-refresh-line align-bottom me-1"></i>{" "}
                              {t('Button Reset')}
                            </button>
                          </div>
                        </Col>
                      </Row>
                    </NestingFilter>
                    {/* <Col sm={12} md={12} xl={12} xxl={12} className="mt-4 px-3 px-lg-0">
                      <div>
                        <div className="d-flex gap-2 flex-wrap">
                          <button type="button" className={`btn px-3 px-md-4 py-btn-section  ${String(query?.section) === '' ? 'bg-primary text-white' : 'border-gray text-secondary'}`}
                            onClick={(e) => { e.preventDefault(); handelChangeSection({ label: t('All'), value: '' }) }}
                          >
                            {t('All')}
                          </button>
                          {SECTION_KEYWORD_OPTIONS_LANG?.map((item) => (
                            <button type="button" className={`btn px-3 px-md-4 py-btn-section ${String(query?.section) === String(item?.value) ? `bg-primary text-white` : `border-gray text-secondary`}`} key={item?.value}
                              onClick={(e) => { e.preventDefault(); handelChangeSection(item) }}
                            >
                              {item?.label}
                            </button>
                          ))}
                        </div>
                      </div>
                    </Col> */}
                  </div>
                  <CardBody className="pt-0 px-0">
                    <div className="mx-3 my-4 mt-3">
                      <NewsTableContainer
                        className="custom-header-css"
                        divClass="table-responsive table-card"
                        tableClass="align-middle sticky-table-my-news"
                        theadClass="table-light"
                        columns={columns}
                        data={listNews?.list?.length ? listNews?.list : []}
                        customPageSize={query.limit}
                        customPageIndex={query.page - 1}
                        totalRecords={listNews?.total}
                        customPageCount={Math.ceil(Number(listNews?.total) / Number(query?.limit || 300))}
                        handleChangePage={handleChangePage}
                        manualSorting={true}
                        sorting={{ sort_by: query.sort_by, order_by: query.order_by }}
                        handleChangeSorting={handleChangeSorting}
                        isLoading={isListNewsLoading}
                        typeShowList={typeShowList}
                        handleClickDetailCard={handleSetNewsDetail}
                        isShowPagination={true}
                        isShowLoadingBottom={false}
                        isScrollToTop={true}
                      />
                    </div>
                  </CardBody>
                </Card>
              </Col>
            )}</Row>
        </Container>
        <ToastContainer closeButton={false} newestOnTop={false} pauseOnFocusLoss autoClose={2000} limit={2} />

        <Modal
          isOpen={!!newsDetail}
          centered={window?.innerWidth > 900 ? true : false}
          size="xl"
          className={`border-header-footer  ${window?.innerWidth > 900 ? '' : 'modal-fullscreen '}`}
          scrollable={window?.innerWidth > 900 ? true : false}
          toggle={onCloseClick}
          keyboard={true}
          innerRef={modalRef}
        >
          <ModalHeader toggle={onCloseClick}>
            <div className="d-flex flex-column flex-sm-row gap-0 gap-sm-2 fs-18 fs-md-20">
              <div className="flex-grow-1">
                {t('AI News')}: <span style={{ backgroundColor: '#ffff00' }}>{newsDetail?.keyword || ''}</span>
                <ButtonGroup>
                  <UncontrolledDropdown>
                    <DropdownToggle tag="button" className="btn btn-light btn-sm fs-14 px-2 ms-3  d-flex justify-content-center align-item-center btn-width-lang-news">
                      {/* <i className="ri-translate" />  */}
                      <img
                        src={FLAGS[currentLang] || FLAGS['ko']}
                        alt="Header Language"
                        height="20"
                        className="rounded"
                      />
                      <span className="ms-1">
                        {t(currentLang)}
                      </span> <i className=" ms-1 mdi mdi-chevron-down"></i>
                    </DropdownToggle>
                    <DropdownMenu>
                      <DropdownItem onClick={() => handleChangeLang('ko')}>
                        <div className="d-flex align-items-center">
                          <img
                            src={FLAGS['ko']}
                            alt="Header Language"
                            height="20"
                            className="rounded me-2"
                          />
                          {t('ko')}
                        </div>
                      </DropdownItem>
                      <DropdownItem divider />
                      <DropdownItem onClick={() => handleChangeLang('en')}>
                        <div className="d-flex align-items-center" >
                          <img
                            src={FLAGS['en']}
                            alt="Header Language"
                            height="20"
                            className="rounded me-2"
                          />{t('en')}
                        </div>
                      </DropdownItem>
                      <DropdownItem divider />
                      <DropdownItem onClick={() => handleChangeLang('cn-zh')}>
                        <div className="d-flex align-items-center">
                          <img
                            src={FLAGS['cn-zh']}
                            alt="Header Language"
                            height="20"
                            className="rounded me-2"
                          />{t('cn-zh')}
                        </div>
                      </DropdownItem>
                      <DropdownItem divider />
                      <DropdownItem onClick={() => handleChangeLang('ja')}>
                        <div className="d-flex align-items-center">
                          <img
                            src={FLAGS['ja']}
                            alt="Header Language"
                            height="20"
                            className="rounded me-2"
                          />{t('ja')}
                        </div>
                      </DropdownItem>
                    </DropdownMenu>

                  </UncontrolledDropdown>
                </ButtonGroup>
                <span className={`mx-2 rounded-pill badge bg-${COLORS_STATUS_NEWS[`${newsDetail?.status || 0}`] || 'success'}`}>
                  {STATUS_NEWS_OPTIONS_LANG?.find((s) => String(s?.value) === String(newsDetail?.status))?.label || ''}
                </span>
                <span key={newsDetail?.section} className={`rounded-pill me-2 badge bg-${COLORS_SECTION_KEYWORD[`${newsDetail?.section || ''}`] || 'success'}-subtle text-${COLORS_SECTION_KEYWORD[`${newsDetail?.section || ''}`] || 'success'}`}>
                  {SECTION_KEYWORD_OPTIONS_LANG?.find((s) => String(s?.value) === String(newsDetail?.section))?.label || ''}
                </span>
              </div>
              {/* <div className="d-flex flex-grow-1">
                <div>
                  <span key={newsDetail?.section} className={`rounded-pill me-2 badge bg-${COLORS_SECTION_KEYWORD[`${newsDetail?.section || ''}`] || 'success'}-subtle text-${COLORS_SECTION_KEYWORD[`${newsDetail?.section || ''}`] || 'success'}`}>
                    {SECTION_KEYWORD_OPTIONS_LANG?.find((s) => String(s?.value) === String(newsDetail?.section))?.label || ''}
                  </span>
                </div>
              </div> */}
            </div>
          </ModalHeader>
          <ModalBody className="position-relative">
            <div ref={modalBodyInnerRef} className="inner-modal-body color-scrollbar-os ">
              <CopyPreventionComponent isCopy={true}>
                <div className="pb-3">
                  <p className="mb-3 fs-22 fs-md-23" style={{ lineHeight: '170%', fontWeight: 600 }}>
                    <CopyTextToClipboard text={newsDetail?.title || ''} isCopy={true}>
                      <HighlightText text={newsDetail?.title || ''} keyword={newsDetail?.keyword || ''} />
                    </CopyTextToClipboard>
                  </p>
                  <p className="mb-3 mt-3 fs-17 fs-md-18" style={{ whiteSpace: 'pre-line', lineHeight: '170%' }}>
                    <CopyTextToClipboard text={newsDetail?.body || ''} isCopy={true}>
                      <HighlightText text={newsDetail?.body || ''} keyword={newsDetail?.keyword || ''} />
                    </CopyTextToClipboard>
                  </p>
                </div>
              </CopyPreventionComponent>
            </div>
            {/* <DraggableButtons newsDetail={newsDetail} isDownloading={isDownloading} handlePreviousNews={handlePreviousNews} handleNextNews={handleNextNews} /> */}
          </ModalBody>
          <ModalFooter className="footer-button-new" lang={i18n?.language || 'en'}>
            <div className="w-100 d-flex gap-2 justify-content-between align-items-center flex-wrap">
              <strong>
                <div className="d-flex align-items-center">
                  <div className="flex-shrink-0 fs-14 fs-md-16">
                    {t('The count of keyword occurrences in the news')}:
                  </div>
                  <div className="flex-grow-1 fs-14 fs-md-16 ms-1">
                    <span className="fw-medium">{Number(newsDetail?.title_count || 0) + Number(newsDetail?.body_count || 0)}</span>
                  </div>
                </div>
              </strong>
              <div className="d-flex flex-grow-1 gap-2 gap-sm-3 justify-content-end justify-content-sm-end mt-2 mt-sm-0 flex-wrap-sm-300">
                <div className="btn-group btn-width-next-news"
                >
                  <button type="button" title={t('Previous News')} style={{ height: '40px' }} aria-pressed="false"
                    className="btn fs-14 btn-secondary d-flex justify-content-center align-item-center"
                    disabled={isListNewsLoading || isDownloading || !!newsDetail?.disabled_prev}
                    onClick={() => handlePreviousNews(newsDetail?.index)}
                  >
                    {(isListNewsLoading && query?.type_page_no_param === 'prev') ? <span style={{ transform: 'translateY(3px)', width: '18px' }}><Spinner size="sm" ></Spinner></span> : <FeatherIcon style={{ width: '18px' }} icon="chevron-left" className="fs-14" role="img" />}
                  </button>
                  <button type="button" title={t('Next News')} style={{ height: '40px' }} aria-pressed="false"
                    className="btn fs-14 btn-secondary d-flex justify-content-center align-item-center"
                    disabled={isListNewsLoading || isDownloading || !!newsDetail?.disabled_next}
                    onClick={() => handleNextNews(newsDetail?.index)}
                  >
                    {(isListNewsLoading && query?.type_page_no_param === 'next') ? <span style={{ transform: 'translateY(3px)', width: '18px' }}><Spinner size="sm" ></Spinner></span> : <FeatherIcon style={{ width: '18px' }} icon="chevron-right" className="fs-14" role="img" />}
                  </button>
                </div>
                <button
                  className="btn btn-primary fs-14 px-1 d-flex justify-content-center align-item-center btn-width-photo-news"
                  type="button"
                  color="light"
                  onClick={() => handleConfirmPhotoNews()}
                  disabled={isDownloading || isCopyLoading}
                >
                  <i className="ri ri-image-line" style={{ lineHeight: '22px' }} /><span className="ms-1">{t("Photo")}</span>
                </button>
                {/* <button
                    className="btn btn-danger fs-14 px-1 d-flex justify-content-center align-item-center"
                    type="button"
                    color="light"
                    onClick={() => handleSetNewsCancel(newsDetail)}
                    style={{ width: '80px' }}
                    disabled={isDownloading}
                  >
                    <i className="ri-subtract-line" /><span className="ms-1">{t("Button Cancel News")}</span>
                  </button> */}
                <button
                  className="btn btn-primary btn-width-copy-news fs-14 px-1 d-flex justify-content-center align-item-center"
                  type="button"
                  color="light"
                  onClick={() => handleCopyNews(newsDetail?.id)}
                  disabled={isDownloading || isCopyLoading}
                >
                  {isCopyLoading ? <span><Spinner size="sm" ></Spinner></span> : <i className="ri ri-file-copy-line" style={{ lineHeight: '22px' }} />} <span className="ms-1">{t("Copy")}</span>
                </button>
                <ButtonGroup>
                  <UncontrolledDropdown>
                    <DropdownToggle tag="button" className="btn btn-primary fs-14 px-1 d-flex justify-content-center align-item-center btn-width-down-news" disabled={isDownloading || isCopyLoading} >
                      {isDownloading ? <span><Spinner size="sm" ></Spinner></span> : <i className="ri-download-line" />} <span className="ms-1">{t("Button Use News")}</span> <i className=" ms-1 mdi mdi-chevron-down"></i>
                    </DropdownToggle>
                    <DropdownMenu>
                      <DropdownItem onClick={() => handleDownloadNews(newsDetail?.id, 'WORD')}>{t('File Word')}</DropdownItem>
                      <DropdownItem divider />
                      <DropdownItem onClick={() => handleDownloadNews(newsDetail?.id, 'PDF')}>{t('File PDF')}</DropdownItem>
                      {/* <DropdownItem divider />
                        <DropdownItem onClick={() => handleCopyNews(newsDetail?.id)}>{t('Copy')}</DropdownItem> */}
                    </DropdownMenu>
                  </UncontrolledDropdown>
                </ButtonGroup>
                <button
                  className="btn btn-secondary fs-14 px-1 d-flex justify-content-center align-item-center btn-width-close-news"
                  type="button"
                  color="light"
                  onClick={onCloseClick}
                  disabled={isDownloading}
                >
                  <i className="ri-close-fill" style={{ lineHeight: '22px' }} /> <span className="ms-1">{t("Button Close")}</span>
                </button>
              </div>
            </div>
          </ModalFooter>
        </Modal>
        <ModalConfirm
          // innerRef={modalConfirmRef}
          header={
            <div className="d-flex flex-column flex-sm-row gap-0 gap-sm-2 fs-18 fs-md-20">
              <div className="flex-grow-1">
                {t('Button Cancel News')}: <span style={{ backgroundColor: '#ffff00' }}>{newsCancel?.keyword || ''}</span>
              </div>
              <div className="d-flex flex-grow-1">
                <div>
                  {(newsCancel?.sections || [])?.map((section: any) => (
                    <span key={section} className={`rounded-pill me-2 badge bg-${COLORS_SECTION_KEYWORD[`${section || ''}`] || 'success'}-subtle text-${COLORS_SECTION_KEYWORD[`${section || ''}`] || 'success'}`}>
                      {SECTION_KEYWORD_OPTIONS_LANG?.find((s) => String(s?.value) === String(section))?.label || ''}
                    </span>
                  ))}
                </div>
              </div>
            </div>
          }
          textButtonConfirm={t('Button Cancel News')}
          title={t("Are you sure you want to cancel?")}
          content={t("After confirming the cancel action, the data will be permanently removed and cannot be recovered. Do you want to proceed with the cancel action.")}
          isOpen={newsCancel !== null}
          classIconButtonConfirm={''}
          isLoading={isConfirmLoading}
          isShowIcon={false}
          onClose={onCloseConfirmClick}
          onConfirm={handleActionCancel}
        />

        <Modal
          isOpen={!!isOpenPhoto}
          centered={true}
          // size="sm"
          toggle={() => setIsOpenPhoto(false)}
          keyboard={true}
        >
          <ModalHeader>
            {t('Photo')}
          </ModalHeader>
          <ModalBody className="">
            <div className="row g-4">
              <Col sm={12}>
                <div className="row g-3">
                  <div className="mt-3 text-center">
                    <h6 className="mb-2 fs-19 text-center">
                      {t("Would you like to proceed to Google Images?")}
                    </h6>
                    <p className="fs-15 mb-4 d-flex justify-content-center align-items-start align-items-sm-center text-center "> <i className="ri-error-warning-line me-1 fs-18" /> {t("The responsibility for photo copyrights lies with you.")}</p>
                    <div className="d-flex gap-3 mt-2 justify-content-center">
                      <button
                        className={`btn rounded-pill btn-soft-primary fs-14`}
                        type="button"
                        onClick={handleOpenTabPhotoNews}
                        style={{ minWidth: '100px' }}
                      >

                        {t("Button Move")}
                      </button>
                      <button
                        className="btn btn-soft-secondary rounded-pill fs-14"
                        type="button"
                        color="light"
                        onClick={() => setIsOpenPhoto(false)}
                        style={{ minWidth: '100px' }}
                      >
                        {t("Button Close")}
                      </button>
                    </div>
                  </div>
                </div>
              </Col>
            </div>
          </ModalBody>
        </Modal >
      </div >
    </React.Fragment >
  );
};

export default NewsList;